import * as reddit2fa from './reddit2fa'
import * as redditChat from './redditChat'
import * as redditContentCommunityVisibility from './redditContentCommunityVisibility'
import * as redditDeleteComments from './redditDeleteComments'
import * as redditDeletePosts from './redditDeletePosts'
import * as redditDiscoverability from './redditDiscoverability'
import * as redditEmailNotifications from './redditEmailNotifications'
import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './redditGatherMachine'
import * as redditNotifications from './redditNotifications'
import * as redditPersonalizedAds from './redditPersonalizedAds'
import * as redditThirdPartyAccess from './redditThirdPartyAccess'
import { RedditRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [RedditRecommendationKey.REDDIT_DISCOVERABILITY]: redditDiscoverability,
  [RedditRecommendationKey.REDDIT_CONTENT_COMMUNITY_VISIBILITY]:
    redditContentCommunityVisibility,
  [RedditRecommendationKey.REDDIT_2FA]: reddit2fa,
  [RedditRecommendationKey.REDDIT_CHAT]: redditChat,
  [RedditRecommendationKey.REDDIT_THIRD_PARTY_ACCESS]: redditThirdPartyAccess,
  [RedditRecommendationKey.REDDIT_PERSONALIZED_ADS]: redditPersonalizedAds,
  [RedditRecommendationKey.REDDIT_NOTIFICATIONS]: redditNotifications,
  [RedditRecommendationKey.REDDIT_EMAIL_NOTIFICATIONS]:
    redditEmailNotifications,
  [RedditRecommendationKey.REDDIT_PUBLIC_VIEW]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        RedditRecommendationKey.REDDIT_PUBLIC_VIEW,
      ),
    ],
  },
  [RedditRecommendationKey.REDDIT_DELETE_POSTS]: redditDeletePosts,
  [RedditRecommendationKey.REDDIT_DELETE_COMMENTS]: redditDeleteComments,
}

export const redditRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => getAccountUsernameGatherStageDefs(),
  getAdditionalFullGatherStageDefs: () => getAdditionalFullGatherStageDefs(),
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
